import appModule from "./modules/app.module";
import { createStore } from "vuex";

export default createStore({
  state: {},
  mutation: {},
  actions: {},
  modules: appModule,
});
